import {Component, Input, OnInit, OnDestroy, OnChanges, SimpleChanges} from '@angular/core';
import { Iproject } from 'src/app/models/project.model';
import { MobileCheck } from '../../services/mobile-check/mobile-check.service';
import { Subject, takeUntil } from 'rxjs';
import {IBatch} from "../../models/batch.model";
import {ColorComponent} from "../../shared/components/color/color.component";
import {MatCard} from "@angular/material/card";
import {TranslateModule} from "@ngx-translate/core";
import {MatGridList, MatGridTile} from "@angular/material/grid-list";
import {MatTooltip} from "@angular/material/tooltip";
import {MatIcon} from "@angular/material/icon";
import {NgClass} from "@angular/common";

@Component({
  selector: 'colimo-color-card',
  templateUrl: './color-card.component.html',
  styleUrls: ['./color-card.component.scss'],
  imports: [
    ColorComponent,
    MatCard,
    TranslateModule,
    MatGridTile,
    MatTooltip,
    MatGridList,
    MatIcon,
    NgClass
  ]
})
export class ColorCardComponent implements OnInit, OnChanges, OnDestroy {
  @Input() public project: Iproject;

  public isMobile: boolean;
  public productBatches: any[];
  public hasInLineBatches: boolean;
  private stop$: Subject<boolean> = new Subject();

  constructor(private mobileCheck: MobileCheck) {}

  public ngOnInit(): void {
    this.mobileCheck.getScreenSize().pipe(takeUntil(this.stop$)).subscribe((device) => {
      this.isMobile = device.isMobile;
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['project']) {
      // #441303 evaluate products with inline batches to display correctly aligned on the color cars details
      if (this.project && this.project.products) {
        this.productBatches = [];
        this.hasInLineBatches = false;
        for (let i = 0; i < this.project.products.length; i++) {
          this.productBatches.push({
            product: this.project.products[i],
            inLineBatches: this.getInLineBatches(this.project.products[i].batches) // this.project.products[i].batches.filter((batch) => { return batch.state === 'IN_LINE' })
          })
        }
      }
    }
  }

  private getInLineBatches(batches: IBatch[]): IBatch[] {
    // filter for batches with state = 'IN_LINE' and set corresponding variable to switch between inline batches or no batches template in html
    const inLineBatches = batches.filter((batch) => { return batch.state === 'IN_LINE' });
    if (inLineBatches.length > 0) {
      this.hasInLineBatches = true;
    }
    return inLineBatches;
  }

  public ngOnDestroy(): void {
    this.stop$.next(true);
    this.stop$.unsubscribe();
  }

  protected readonly Math = Math;
}
